import type { SVGProps } from 'react'
const SvgSyUserAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={8} r={4} />
		<path
			fillOpacity={0.24}
			d="M5.338 17.32C5.999 14.528 8.772 13 11.643 13h.714c2.871 0 5.644 1.527 6.305 4.32.128.541.23 1.107.287 1.682.055.55-.397.998-.949.998H6c-.552 0-1.004-.449-.949-.998.057-.575.159-1.14.287-1.681"
		/>
	</svg>
)
export default SvgSyUserAlt
